import axios from "axios";
import * as Config from "../../../router/config";

const state = {
 crm_loaded: false,
 // CRM Attributes
 pay_cycle: [],
 timesheet_cycle: [],
 payment_term: [],
 vat_percentage: [],
 rate_type: [],
 pay_type: [],
 person_title: [],
 worker_employment_type: [],
 utr_status: [],
 fee_type: [],
 worker_bank_type: [],
 company_address_type: [],
 worker_address_type: [],
 company_phone_type: [],
 contact_phone_type: [],
 worker_phone_type: [],
 company_email_type: [],
 contact_email_type: [],
 worker_email_type: [],
 recruitment_order_type: [],
 payroll_client_solution: [],
 payroll_trading_company: [],
 payroll_order_type: [],
 worker_application_status: [],
 news_article_category: [],
 company_type: [],
 company_pipeline_status: [],
 company_pipeline_opportunity_size: [],
 // CRM
 divisions: [],
 job_titles: [],
 nationalities: [],
 qualifications: [],
 recruitment_departments: [],
 relationships: [],
 sectors: [],
 worker_recruitment_job_types: [],
 // NOTES
 note_types: [],
 // FILES
 file_types: []
};
const actions = {
 //
 // CRM Attributes
 //
 load_pay_cycle({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/pay_cycle').then(pay_cycle => {
    commit('COMMIT_PAY_CYCLE', pay_cycle.data);
    resolve();
   })
  })
 },
 load_timesheet_cycle({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/timesheet_cycle').then(timesheet_cycle => {
    commit('COMMIT_TIMESHEET_CYCLE', timesheet_cycle.data);
    resolve();
   })
  })
 },
 load_payment_term({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/payment_term').then(payment_term => {
    commit('COMMIT_PAYMENT_TERM', payment_term.data);
    resolve();
   })
  })
 },
 load_vat_percentage({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/vat_percentage').then(vat_percentage => {
    commit('COMMIT_VAT_PERCENTAGE', vat_percentage.data);
    resolve();
   })
  })
 },
 load_rate_type({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/rate_type').then(rate_type => {
    commit('COMMIT_RATE_TYPE', rate_type.data);
    resolve();
   })
  })
 },
 load_pay_type({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/pay_type').then(pay_type => {
    commit('COMMIT_PAY_TYPE', pay_type.data);
    resolve();
   })
  })
 },
 load_person_title({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/person_title').then(person_title => {
    commit('COMMIT_PERSON_TITLE', person_title.data);
    resolve();
   })
  })
 },
 load_worker_employment_type({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/worker_employment_type').then(worker_employment_type => {
    commit('COMMIT_WORKER_EMPLOYMENT_TYPE', worker_employment_type.data);
    resolve();
   })
  })
 },
 load_utr_status({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/utr_status').then(utr_status => {
    commit('COMMIT_UTR_STATUS', utr_status.data);
    resolve();
   })
  })
 },
 load_fee_type({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/fee_type').then(fee_type => {
    commit('COMMIT_FEE_TYPE', fee_type.data);
    resolve();
   })
  })
 },
 load_worker_bank_type({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/worker_bank_type').then(worker_bank_type => {
    commit('COMMIT_WORKER_BANK_TYPE', worker_bank_type.data);
    resolve();
   })
  })
 },
 load_company_address_type({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/company_address_type').then(company_address_type => {
    commit('COMMIT_COMPANY_ADDRESS_TYPE', company_address_type.data);
    resolve();
   })
  })
 },
 load_worker_address_type({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/worker_address_type').then(worker_address_type => {
    commit('COMMIT_WORKER_ADDRESS_TYPE', worker_address_type.data);
    resolve();
   })
  })
 },
 load_company_phone_type({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/company_phone_type').then(company_phone_type => {
    commit('COMMIT_COMPANY_PHONE_TYPE', company_phone_type.data);
    resolve();
   })
  })
 },
 load_contact_phone_type({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/company_phone_type').then(contact_phone_type => {
    commit('COMMIT_CONTACT_PHONE_TYPE', contact_phone_type.data);
    resolve();
   })
  })
 },
 load_worker_phone_type({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/worker_phone_type').then(worker_phone_type => {
    commit('COMMIT_WORKER_PHONE_TYPE', worker_phone_type.data);
    resolve();
   })
  })
 },
 load_company_email_type({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/company_email_type').then(company_email_type => {
    commit('COMMIT_COMPANY_EMAIL_TYPE', company_email_type.data);
    resolve();
   })
  })
 },
 load_contact_email_type({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/contact_email_type').then(contact_email_type => {
    commit('COMMIT_CONTACT_EMAIL_TYPE', contact_email_type.data);
    resolve();
   })
  })
 },
 load_worker_email_type({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/worker_email_type').then(worker_email_type => {
    commit('COMMIT_WORKER_EMAIL_TYPE', worker_email_type.data);
    resolve();
   })
  })
 },
 load_recruitment_order_type({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/recruitment_order_type').then(recruitment_order_type => {
    commit('COMMIT_RECRUITMENT_ORDER_TYPE', recruitment_order_type.data);
    resolve();
   })
  })
 },
 load_payroll_client_solution({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/payroll_client_solution').then(payroll_client_solution => {
    commit('COMMIT_PAYROLL_CLIENT_SOLUTION', payroll_client_solution.data);
    resolve();
   })
  })
 },
 load_payroll_trading_company({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/payroll_trading_company').then(payroll_trading_company => {
    commit('COMMIT_PAYROLL_TRADING_COMPANY', payroll_trading_company.data);
    resolve();
   })
  })
 },
 load_payroll_order_type({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/payroll_order_type').then(payroll_order_type => {
    commit('COMMIT_PAYROLL_ORDER_TYPE', payroll_order_type.data);
    resolve();
   })
  })
 },
 load_worker_application_status({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/worker_application_status').then(worker_application_status => {
    commit('COMMIT_WORKER_APPLICATION_STATUS', worker_application_status.data);
    resolve();
   })
  })
 },
 load_news_article_category({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/news_article_category').then(news_article_category => {
    commit('COMMIT_NEWS_ARTICLE_CATEGORY', news_article_category.data);
    resolve();
   })
  })
 },
 load_company_type({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/company_type').then(company_type => {
    commit('COMMIT_COMPANY_TYPE', company_type.data);
    resolve();
   })
  })
 },
 load_company_pipeline_status({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/company_pipeline_status').then(company_pipeline_status => {
    commit('COMMIT_COMPANY_PIPELINE_STATUS', company_pipeline_status.data);
    resolve();
   })
  })
 },
 load_company_pipeline_opportunity_size({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/company_pipeline_opportunity_size').then(company_pipeline_opportunity_size => {
    commit('COMMIT_COMPANY_PIPELINE_OPPORTUNITY_SIZE', company_pipeline_opportunity_size.data);
    resolve();
   })
  })
 },
 //
 // CRM
 //
 load_divisions({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/divisions').then(divisions => {
    commit('COMMIT_DIVISIONS', divisions.data);
    resolve();
   })
  })
 },
 load_job_titles({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/get_job_titles').then(job_titles => {
    commit('COMMIT_JOB_TITLES', job_titles.data);
    resolve();
   })
  })
 },
 load_nationalities({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/nationalities').then(nationalities => {
    commit('COMMIT_NATIONALITIES', nationalities.data);
    resolve();
   })
  })
 },
 load_qualifications({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/qualifications').then(qualifications => {
    commit('COMMIT_QUALIFICATIONS', qualifications.data);
    resolve();
   })
  })
 },
 load_recruitment_departments({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/recruitment_departments').then(recruitment_departments => {
    commit('COMMIT_RECRUITMENT_DEPARTMENTS', recruitment_departments.data);
    resolve();
   })
  })
 },
 load_relationships({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/relationships').then(relationships => {
    commit('COMMIT_RELATIONSHIPS', relationships.data);
    resolve();
   })
  })
 },
 load_sectors({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/sectors').then(sectors => {
    commit('COMMIT_SECTORS', sectors.data);
    resolve();
   })
  })
 },
 load_worker_recruitment_job_types({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/attributes/worker_recruitment_job_types').then(worker_recruitment_job_types => {
    commit('COMMIT_WORKER_RECRUITMENT_JOB_TYPES', worker_recruitment_job_types.data);
    resolve();
   })
  })
 },
 // NOTES
 load_note_types({commit}, payload) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/note_types/' + payload).then(note_types => {
    commit('COMMIT_NOTE_TYPES', note_types.data);
    resolve();
   })
  });
 },
 // FILE TYPES
 load_file_types({commit}) {
  return new Promise(resolve => {
   axios.get(Config.apiPath + 'crm/file_types').then(file_types => {
    commit('COMMIT_FILE_TYPES', file_types.data)
    resolve();
   })
  })
 }
};
const mutations = {
 COMMIT_CRM_LOADED(state, payload) {
  state.crm_loaded = payload;
 },
 //
 // CRM Attributes
 //
 COMMIT_PAY_CYCLE(state, pay_cycle) {
  state.pay_cycle = pay_cycle
 },
 COMMIT_TIMESHEET_CYCLE(state, timesheet_cycle) {
  state.timesheet_cycle = timesheet_cycle
 },
 COMMIT_PAYMENT_TERM(state, payment_term) {
  state.payment_term = payment_term
 },
 COMMIT_VAT_PERCENTAGE(state, vat_percentage) {
  state.vat_percentage = vat_percentage
 },
 COMMIT_RATE_TYPE(state, rate_type) {
  state.rate_type = rate_type
 },
 COMMIT_PAY_TYPE(state, pay_type) {
  state.pay_type = pay_type
 },
 COMMIT_PERSON_TITLE(state, person_title) {
  state.person_title = person_title
 },
 COMMIT_WORKER_EMPLOYMENT_TYPE(state, worker_employment_type) {
  state.worker_employment_type = worker_employment_type
 },
 COMMIT_UTR_STATUS(state, utr_status) {
  state.utr_status = utr_status
 },
 COMMIT_FEE_TYPE(state, fee_type) {
  state.fee_type = fee_type
 },
 COMMIT_WORKER_BANK_TYPE(state, worker_bank_type) {
  state.worker_bank_type = worker_bank_type
 },
 COMMIT_COMPANY_ADDRESS_TYPE(state, company_address_type) {
  state.company_address_type = company_address_type
 },
 COMMIT_WORKER_ADDRESS_TYPE(state, worker_address_type) {
  state.worker_address_type = worker_address_type
 },
 COMMIT_COMPANY_PHONE_TYPE(state, company_phone_type) {
  state.company_phone_type = company_phone_type
 },
 COMMIT_CONTACT_PHONE_TYPE(state, contact_phone_type) {
  state.contact_phone_type = contact_phone_type
 },
 COMMIT_WORKER_PHONE_TYPE(state, worker_phone_type) {
  state.worker_phone_type = worker_phone_type
 },
 COMMIT_COMPANY_EMAIL_TYPE(state, company_email_type) {
  state.company_email_type = company_email_type
 },
 COMMIT_CONTACT_EMAIL_TYPE(state, contact_email_type) {
  state.contact_email_type = contact_email_type
 },
 COMMIT_WORKER_EMAIL_TYPE(state, worker_email_type) {
  state.worker_email_type = worker_email_type
 },
 COMMIT_RECRUITMENT_ORDER_TYPE(state, recruitment_order_type) {
  state.recruitment_order_type = recruitment_order_type
 },
 COMMIT_PAYROLL_CLIENT_SOLUTION(state, payroll_client_solution) {
  state.payroll_client_solution = payroll_client_solution
 },
 COMMIT_PAYROLL_TRADING_COMPANY(state, payroll_trading_company) {
  state.payroll_trading_company = payroll_trading_company
 },
 COMMIT_PAYROLL_ORDER_TYPE(state, payroll_order_type) {
  state.payroll_order_type = payroll_order_type
 },
 COMMIT_WORKER_APPLICATION_STATUS(state, worker_application_status) {
  state.worker_application_status = worker_application_status
 },
 COMMIT_NEWS_ARTICLE_CATEGORY(state, news_article_category) {
  state.news_article_category = news_article_category
 },
 COMMIT_COMPANY_TYPE(state, company_type) {
  state.company_type = company_type
 },
 COMMIT_COMPANY_PIPELINE_STATUS(state, company_pipeline_status) {
  state.company_pipeline_status = company_pipeline_status
 },
 COMMIT_COMPANY_PIPELINE_OPPORTUNITY_SIZE(state, company_pipeline_opportunity_size) {
  state.company_pipeline_opportunity_size = company_pipeline_opportunity_size
 },
 //
 // CRM
 //
 COMMIT_DIVISIONS(state, divisions) {
  state.divisions = divisions
 },
 COMMIT_JOB_TITLES(state, job_titles) {
  state.job_titles = job_titles
 },
 COMMIT_NATIONALITIES(state, nationalities) {
  state.nationalities = nationalities
 },
 COMMIT_QUALIFICATIONS(state, qualifications) {
  state.qualifications = qualifications
 },
 COMMIT_RECRUITMENT_DEPARTMENTS(state, recruitment_departments) {
  state.recruitment_departments = recruitment_departments
 },
 COMMIT_RELATIONSHIPS(state, relationships) {
  state.relationships = relationships
 },
 COMMIT_SECTORS(state, sectors) {
  state.sectors = sectors
 },
 COMMIT_WORKER_RECRUITMENT_JOB_TYPES(state, worker_recruitment_job_types) {
  state.worker_recruitment_job_types = worker_recruitment_job_types;
 },
 // NOTES
 COMMIT_NOTE_TYPES(state, note_types) {
  state.note_types = note_types;
 },
 // FILE TYPES
 COMMIT_FILE_TYPES(state, file_types) {
  state.file_types = file_types
 }
};
export default {
 state,
 actions,
 mutations
}
